module.exports = __webpack_public_path__ + "img/partner1.81f06b46.jpg";